import { Accordion, ControlledDropDown, CustomButton, FormInput } from '@ui-kit'
import { addToaster, useDispatch } from '@app-store'
import { AddMissingInformationType } from '../../types/MissingInformationSummary.types'
import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import { v4 as uuid } from 'uuid'
import {
  MISSING_INFO_POPUP_CONSTANTS,
  MODE_STATUS,
  NAMESPACES,
} from '../../utils/constants'
import { TAB_INDEX } from '../../constants/form.constants'
import { noop } from 'lodash'

const AddMissingInformation = ({
  onSubmit,
  selectedRow,
  miFields,
}: AddMissingInformationType) => {
  const dispatch = useDispatch()
  const methods = useForm<{
    mi_field: string
    status: string
    message: string
  }>({
    defaultValues: {
      mi_field: '',
      status: '',
      message: '',
    },
  })
  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    watch,
    reset,
    setValue,
  } = methods
  useEffect(() => {
    if (selectedRow) {
      reset(selectedRow)
    } else {
      reset({
        mi_field: '',
        message: '',
        status: NAMESPACES.PENDING,
      })
    }
  }, [selectedRow])
  return (
    <Accordion
      heading={
        selectedRow
          ? MISSING_INFO_POPUP_CONSTANTS.EDIT_MISSING_INFO
          : MISSING_INFO_POPUP_CONSTANTS.ADD_MISSING_INFO
      }
      tabIndex={TAB_INDEX}
      className="bg-none"
      borderColor="secondary-500"
      isDisabled={false}
      triggerOpen={!!selectedRow}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-[0.75rem] p-[0.75rem]">
          <div className="gap-[0.40625rem] justify-between w-full grid grid-cols-3">
            <ControlledDropDown
              name={'mi_field'}
              label={MISSING_INFO_POPUP_CONSTANTS.MI_FIELD}
              onChange={() => {
                setValue('message', '')
              }}
              isSearchable={true}
              options={miFields}
              errors={errors}
              control={control}
              dataQaId={MISSING_INFO_POPUP_CONSTANTS.MI_FIELD_LOWERCASE}
              required={true}
              disabled={!!selectedRow}
            />
            <ControlledDropDown
              name={'status'}
              label={NAMESPACES.STATUS}
              onChange={noop}
              isCrossable={false}
              options={[
                {
                  label: MODE_STATUS.PENDING,
                  value: NAMESPACES.PENDING,
                },
                {
                  label: MODE_STATUS.RESOLVED,
                  value: NAMESPACES.RESOLVED,
                },
              ]}
              errors={errors}
              control={control}
              dataQaId={NAMESPACES.STATUS_KEY}
              disabled={!selectedRow}
              required={true}
            />
            {watch('mi_field')?.toLowerCase() === NAMESPACES.OTHER_KEY && (
              <FormInput
                label={NAMESPACES.DESCRIPTION_LABEL}
                placeholder="--"
                errors={errors}
                name={'message'}
                register={register}
                validation={{ required: false }}
                disabled={false}
                dataQaId={NAMESPACES.DESCRIPTION_KEY}
              />
            )}
          </div>
          <div className="flex justify-end gap-[0.75rem]">
            <CustomButton
              color="primary"
              type="button"
              onClick={() => {
                onSubmit(null)
                reset({
                  mi_field: '',
                  message: '',
                  status: NAMESPACES.PENDING,
                })
              }}
            >
              {NAMESPACES.CANCEL_BUTTON}
            </CustomButton>
            <CustomButton
              color="primary"
              isFilled={true}
              type="button"
              onClick={handleSubmit((data) => {
                if (
                  selectedRow &&
                  selectedRow.source_mi_id !== null &&
                  selectedRow.source_mi_id !== undefined &&
                  data.status === NAMESPACES.RESOLVED
                ) {
                  dispatch(
                    addToaster({
                      message: NAMESPACES.BV_COPIED_MI_MSG,
                      type: 'error',
                      id: uuid(),
                      duration: 5000,
                    })
                  )
                  return
                }
                onSubmit(data)
                reset({
                  mi_field: '',
                  message: '',
                  status: NAMESPACES.PENDING,
                })
              })}
            >
              {selectedRow ? NAMESPACES.UPDATE_BUTTON : NAMESPACES.ADD}
            </CustomButton>
          </div>
        </div>
      </form>
    </Accordion>
  )
}

export default AddMissingInformation
